import React, { createContext, useState, useEffect, useCallback } from 'react';


import { getSessionStorage, setSessionStorage } from '../pages/utils/sessionStorageUtils';
import { getAllStatuses, getAreas, getAreasUser, getBairros, getControladoresUsers, getExecutorsUsers, getGroups } from '../components/Search/apiCalls';
import UserPermission from '../components/UserPermission';

export const SearchContext = createContext();

const SearchProvider = ({ children }) => {
    const userPermission = UserPermission();

    const [complaints, setComplaints] = useState([]);

    const [limit, setLimit] = useState(getSessionStorage('limit', 8));
    const [offset, setOffset] = useState(0);
    const [search, setSearch] = useState('');
    const [late, setLate] = useState('Todos');
    const [isLoading, setIsLoading] = useState(true);
    const [area, setArea] = useState(getSessionStorage('area', 'Todos'));
    const [group, setGroup] = useState(getSessionStorage('group', 'Todos'));
    const [bairro, setBairro] = useState(getSessionStorage('bairro', { name: 'Todos' }));
    const [status, setStatus] = useState(getSessionStorage('status', 'Todos'));
    const [complaintTarget, setComplaintTarget] = useState(getSessionStorage('complaintTarget', 'Todos'));
    const [total, setTotal] = useState(0);
    const [listAreas, setListAreas] = useState([{}]);
    const [listGroups, setListGroups] = useState([{ name: 'Todos' }]);
    const [listBairros, setListBairros] = useState([{ name: 'Todos' }]);
    const [searchId, setSearchId] = useState('');
    const [stepStatus, setStepStatus] = useState(getSessionStorage('statusStep', 'Abertura'));
    const [areasUser, setAreasUser] = useState([{ name: 'Todos' }]);
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    const [estadoOcorrencia, setEstadoOcorrencia] = useState(getSessionStorage('occurrenceStatus', 'Todos'));
    const [rangeOccurrences, setRangeOccurrences] = useState(getSessionStorage('rangeOccurrences', 
        {
            startDate: new Date(2021, 0, 1),
            endDate: new Date(),
        }
    ));
    const [allStatuses, setAllStatuses] = useState([]);
    const [executor, setExecutor] = useState(getSessionStorage('executor', 'Todos'));
    const [controlador, setControlador] = useState(getSessionStorage('controlador', 'Todos'));
    const [listExecutors, setListExecutors] = useState([{ name: 'Todos' }]);
    const [listControladores, setListControladores] = useState([{ name: 'Todos' }]);

    // Persistir os valores no sessionStorage quando mudam
    useEffect(() => {
        setSessionStorage('limit', limit);
    }, [limit]);

    useEffect(() => {
        setSessionStorage('area', area);
    }, [area]);

    useEffect(() => {
        setSessionStorage('group', group);
    }, [group]);

    useEffect(() => {
        setSessionStorage('bairro', bairro);
    }, [bairro]);

    useEffect(() => {
        setSessionStorage('status', status);
    }, [status]);

    useEffect(() => {
        setSessionStorage('complaintTarget', complaintTarget);
    }, [complaintTarget]);

    useEffect(() => {
        setSessionStorage('occurrenceStatus', estadoOcorrencia);
    }, [estadoOcorrencia]);

    useEffect(() => {
        setSessionStorage('statusStep', stepStatus);
    }, [stepStatus]);

    useEffect(() => {
        setSessionStorage('rangeOccurrences', rangeOccurrences);
    }
    , [rangeOccurrences]);

    useEffect(() => {
        setSessionStorage('executor', executor);
    }, [executor]);

    useEffect(() => {
        setSessionStorage('controlador', controlador);
    }, [controlador]);

    const fetchData = useCallback(async () => {
        const statuses = await getAllStatuses();
        setAllStatuses(statuses);

        const areas = await getAreasUser();
        setAreasUser(areas);

        const groups = await getGroups();
        setListGroups(groups);

        const bairros = await getBairros();
        setListBairros(bairros);

        const allAreas = await getAreas();
        setListAreas(allAreas);

        if (userPermission !== 'executor') {
            const executors = await getExecutorsUsers();
            setListExecutors(executors);

            const controladores = await getControladoresUsers();
            setListControladores(controladores);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <SearchContext.Provider value={{
            complaints, setComplaints,
            limit, setLimit,
            offset, setOffset,
            search, setSearch,
            late, setLate,
            isLoading, setIsLoading,
            area, setArea,
            group, setGroup,
            bairro, setBairro,
            status, setStatus,
            complaintTarget, setComplaintTarget,
            total, setTotal,
            listAreas, setListAreas,
            listGroups, setListGroups,
            listBairros, setListBairros,
            searchId, setSearchId,
            areasUser, setAreasUser,
            confirmDialog, setConfirmDialog,
            estadoOcorrencia, setEstadoOcorrencia,
            rangeOccurrences, setRangeOccurrences,
            allStatuses, setAllStatuses,
            stepStatus, setStepStatus,
            executor, setExecutor,
            controlador, setControlador,
            listExecutors, setListExecutors,
            listControladores, setListControladores
        }}>
            {children}
        </SearchContext.Provider>
    );
};

export default SearchProvider;
